const defaultRoutes = {
  postLogin: '/home'
};

export { defaultRoutes };
